import { useState } from 'react';

export const useDiscardDialog = () => {
  const [showDiscardDialog, setShowDiscardDialog] = useState(false);
  const [onDiscardConfirm, setOnDiscardConfirm] = useState<(() => void) | null>(null);

  const promptDiscardIfChanged = (isFormChanged: boolean, onProceed: () => void) => {
    if (!isFormChanged) {
      onProceed();
      return;
    }
    setShowDiscardDialog(true);
    setOnDiscardConfirm(() => onProceed);
  };

  const handleDiscardConfirm = () => {
    onDiscardConfirm?.();
    setShowDiscardDialog(false);
    setOnDiscardConfirm(null);
  };

  const handleDiscardCancel = () => {
    setShowDiscardDialog(false);
    setOnDiscardConfirm(null);
  };

  return {
    showDiscardDialog,
    promptDiscardIfChanged,
    handleDiscardConfirm,
    handleDiscardCancel,
  };
};
